import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { CustomThemeProvider } from './context/ThemeContext';
import { THEME_CONFIG } from './config/theme.config';
import ConditionalNavbar from './components/ConditionalNavbar';
import Home from './pages/Home';
import Dashboard from './pages/Dashboard';
import Landing from './pages/Landing';
import SignIn from './pages/SignIn';
import SignUp from './pages/SignUp';
import Profile from './pages/Profile';
import VerifyEmail from './pages/VerifyEmail';
import ResetPassword from './pages/ResetPassword';
import Contact from './pages/Contact';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import BlogEditor from './pages/BlogEditor';
import BlogEditRedirect from './components/BlogEditRedirect';
import CategoryManagement from './pages/CategoryManagement';
import Offers from './pages/Offers';
import OfferDetail from './pages/OfferDetail';
import OfferEditor from './pages/OfferEditor';
import OfferTemplates from './pages/OfferTemplates';
import OffersByCategory from './pages/OffersByCategory';
import SubcategoryOffers from './pages/SubcategoryOffers';
import Brands from './pages/Brands';
import OffersByBrand from './pages/OffersByBrand';
import Users from './pages/Users';
import UserAccounts from './pages/UserAccounts';
import ResizableButtonDemo from './components/ResizableButtonDemo';
import Affiliates from './pages/Affiliates';
import Reporting from './pages/Reporting';
import Optimize from './pages/Optimize';
import SetUps from './pages/SetUps';
import AccountAutomation from './pages/AccountAutomation';
import SiteConfig from './pages/SiteConfig';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import { ENABLE_ACCOUNT_AUTOMATION } from './config';

function App() {
  return (
    <CustomThemeProvider defaultTheme={THEME_CONFIG.DEFAULT_THEME}>
      <AuthProvider>
        <Router>
          <ConditionalNavbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route 
              path="/dashboard" 
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              } 
            />
            <Route path="/signin" element={<SignIn />} />
            <Route path="/signup" element={<SignUp />} />
            <Route path="/verify-email/:token" element={<VerifyEmail />} />
            <Route path="/reset-password/:token" element={<ResetPassword />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/blog" element={<Blog />} />
            <Route
              path="/blog/new"
              element={
                <ProtectedRoute>
                  <BlogEditor />
                </ProtectedRoute>
              }
            />
            <Route
              path="/blog/edit/:id"
              element={
                <ProtectedRoute>
                  <BlogEditRedirect />
                </ProtectedRoute>
              }
            />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/offers" element={<Offers />} />
            <Route path="/offers/by-category" element={<OffersByCategory />} />
            <Route path="/offers/by-brand/:brandId" element={<OffersByBrand />} />
            <Route path="/demo/resizable-button" element={<ResizableButtonDemo />} />
            <Route path="/offers/category/:categoryId/subcategory/:subcategoryId" element={<SubcategoryOffers />} />
            <Route path="/offers/:slug" element={<OfferDetail />} />
            <Route path="/offer-templates" element={<OfferTemplates />} />
            <Route path="/brands" element={<Brands />} />
            <Route
              path="/offers/new"
              element={
                <ProtectedRoute>
                  <OfferEditor />
                </ProtectedRoute>
              }
            />
            <Route
              path="/offers/edit/:id"
              element={
                <ProtectedRoute>
                  <OfferEditor />
                </ProtectedRoute>
              }
            />
            <Route
              path="/categories"
              element={
                <ProtectedRoute>
                  <CategoryManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/users"
              element={
                <ProtectedRoute>
                  <Users />
                </ProtectedRoute>
              }
            />
            <Route
              path="/affiliates"
              element={
                <ProtectedRoute>
                  <UserAccounts />
                </ProtectedRoute>
              }
            />
            <Route
              path="/site-config"
              element={
                <ProtectedRoute>
                  <SiteConfig />
                </ProtectedRoute>
              }
            />
            <Route
              path="/affiliate-partners"
              element={
                <ProtectedRoute>
                  <Affiliates />
                </ProtectedRoute>
              }
            />
            <Route
              path="/reporting"
              element={
                <ProtectedRoute>
                  <Reporting />
                </ProtectedRoute>
              }
            />
            <Route
              path="/optimize"
              element={
                <ProtectedRoute>
                  <Optimize />
                </ProtectedRoute>
              }
            />
            <Route
              path="/setups"
              element={
                <ProtectedRoute>
                  <SetUps />
                </ProtectedRoute>
              }
            />
            <Route
              path="/account-automation"
              element={
                ENABLE_ACCOUNT_AUTOMATION ? (
                  <ProtectedRoute>
                    <AccountAutomation />
                  </ProtectedRoute>
                ) : (
                  <Navigate to="/reporting" replace />
                )
              }
            />
            <Route
              path="/profile"
              element={
                <ProtectedRoute>
                  <Profile />
                </ProtectedRoute>
              }
            />
          </Routes>
        </Router>
      </AuthProvider>
    </CustomThemeProvider>
  );
}

export default App; 